import { fetchUserData, fetchUserProgressData, fetchUserGameState } from "./api.js";
import auth from "./auth.js";

class UserConfig {
    constructor() {
        this.config = {
            user: null,
            userProgress: null,
            songs: null,
            gameState: null,
        };
        // ВАЖНО: Не используем дефолтный userId = 1, так как это может загрузить прогресс другого пользователя
        // userId будет установлен при вызове init() из auth
        this.userId = null;
    }

    async init() {
        try {
            // Получаем userId из авторизации, если пользователь авторизован
            const previousUserId = this.userId;
            
            if (auth.isLoggedIn()) {
                this.userId = auth.getUserId();
            } else {
                // ВАЖНО: Если пользователь не авторизован, не используем дефолтный userId = 1
                // Это может загрузить прогресс другого пользователя
                // Устанавливаем userId в null, чтобы не загружать данные
                this.userId = null;
            }
            
            // Если userId изменился, очищаем кэш перед загрузкой новых данных
            if (previousUserId !== this.userId) {
                this.clearProgressCache();
            }
            
            // Загружаем данные только если userId определен
            if (this.userId) {
                this.config.user = await fetchUserData(this.userId);
                this.config.userProgress = await fetchUserProgressData(this.userId);
                this.config.gameState = await fetchUserGameState(this.userId);
            } else {
                // Если userId не определен, очищаем конфигурацию
                this.config.user = null;
                this.config.userProgress = null;
                this.config.gameState = null;
            }
            
            return true;
        } catch (error) {
            console.error('Ошибка инициализации конфигурации пользователя:', error);
            return false;
        }
    }

    async getConfig() {
        if (!this.config.user) {
            await this.init();
        }
        return this.config;
    }

    getUserId() {
        return this.userId;
    }

    setUserId(id) {
        this.userId = id;
        this.config.user = null;
        this.config.userProgress = null;
    }

    getUserProgress() {
        return this.config.userProgress;
    }

    getCurrentSongId() {
        return this.config.userProgress?.[0]?.song_id;
    }

    getGameState() {
        return this.config.gameState;
    }

    /**
     * Полностью сбрасывает кэш прогресса пользователя и состояние игры,
     * чтобы при следующем запросе данные были заново загружены с сервера.
     */
    clearProgressCache() {
        this.config.user = null;
        this.config.userProgress = null;
        this.config.gameState = null;
        this.config.songs = null;
        // ВАЖНО: НЕ сбрасываем userId на 1, так как это может загрузить прогресс другого пользователя
        // userId будет установлен при следующем вызове init() из auth
        // Если пользователь не авторизован, userId останется null
        if (!auth.isLoggedIn()) {
            this.userId = null;
        }
    }
}

// Создаем экземпляр
const userConfig = new UserConfig();

/**
 * Инициализирует пользовательскую конфигурацию (user и userProgress)
 */
export const initConfig = async () => {
    return await userConfig.init();
};

/**
 * Возвращает актуальную конфигурацию пользователя (ленивая инициализация)
 */
export const getUserConfig = async () => {
    return await userConfig.getConfig();
};
export const getUserGameState = () => userConfig.getGameState();
/**
 * Сбрасывает локальный кэш прогресса и состояния игры.
 * Используется после полного сброса прогресса, чтобы не требовалась перезагрузка страницы.
 */
export const resetCachedUserProgress = () => userConfig.clearProgressCache();
// Прямой экспорт экземпляра убран как неиспользуемый в проекте